import React from 'react';

import ConfigTablePage from '../../../components/ConfigTablePage';
import StaffMemberForm from '../../../components/StaffMemberForm';
import { listStaff, setStaffMemberActive } from '../../../api';

const serial = (s) => s.getBadge()?.getSerialNumber();

const COLUMNS = [
  { label: 'ID', width: '80px', minWidth: 80, render: (s) => String(s.getID()) },
  { label: 'Name', width: 'minmax(160px, 1fr)', minWidth: 160, render: (s) => s.getName() },
  { label: 'Email', width: 'minmax(200px, 1.2fr)', minWidth: 200, render: (s) => s.getEmail() },
  { label: 'Staff type', width: '140px', minWidth: 140, render: (s) => s.getStaffType()?.getName() },
  { label: 'Badge', width: '120px', minWidth: 120, render: (s) => serial(s) == null ? null : String(serial(s)) },
  { label: 'Room', width: '120px', minWidth: 120, render: (s) => s.getAssignedRoom()?.getIdentifier() },
  { label: 'Status', width: '100px', minWidth: 100, render: (s) => s.getIsActive() === false ? 'Inactive' : 'Active' }
];

/**
 * Staff are deactivated rather than deleted: the server keeps the record.
 * Everywhere else an inactive member of staff is hidden, so this table lists
 * them too, with a way back.
 */
const toggle = (row, { reload, setError, setSuccess }) => {
  const active = row.getIsActive() !== false;
  return [{
    label: active ? 'Deactivate' : 'Reactivate',
    tone: active ? 'danger' : undefined,
    // Deactivating is asked about first: one stray click took a member of
    // staff out of a live school. Reactivating puts someone back, so it is not.
    confirm: active ? {
      title: 'Deactivate ' + row.getName() + '?',
      body: 'They will show as inactive. Their record and badge assignment are kept, and you can reactivate them from this table.'
    } : undefined,
    onClick: () => setStaffMemberActive(row.getID(), !active)
      .then(() => {
        setSuccess(row.getName() + (active ? ' deactivated.' : ' reactivated.'));
        reload();
      })
      .catch((error) => setError(error ?? 'Unable to update ' + row.getName() + '.'))
  }];
};

export default function Staff() {
  return (
    <ConfigTablePage
      title='Staff'
      singular='staff member'
      columns={COLUMNS}
      load={() => listStaff({ includeInactive: true })}
      idOf={(s) => s.getID()}
      searchText={(s) => [s.getName(), s.getEmail(), serial(s)].filter(Boolean).join(' ')}
      searchPlaceholder='Search name or email'
      renderForm={(row, onSaved) => <StaffMemberForm staffMember={row ?? undefined} onSuccess={onSaved} />}
      moreActions={toggle}
    />
  );
}
